import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const TCR = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.tcr.title')}
      contentType="tcr"
      description={t('page.tcr.desc')}
      outputLabel={t('page.tcr.output')}
      showDurationSelector
      programMode
    />
  );
};
